import { IFinancialAssetsUpdate } from "./interfaces";
import dayjs from "dayjs";

export function UpdateFinancialAssets(this: IFinancialAssetsUpdate) {
  const {
    assetId,
    entityId,
    entityType,
    comment,
    estimatedValue,
    valuationAmount,
    valuationDate,
    financialInstitutionName,
    financialInstitutionAddress1,
    financialInstitutionAddress2,
    nin,
    financialInstitutionPostalCode,
    financialInstitutionMunicipalityCode,
    description,
  } = this;
  return {
    assetId,
    entityId,
    entityType,
    nameOrType: comment,
    estimatedValue,
    valuationAmount,
    valuationDate:
      valuationDate && dayjs(valuationDate).isValid()
        ? dayjs(valuationDate).format("YYYY-MM-DD")
        : null,
    financialInstitutionName,
    financialInstitutionAddress1,
    financialInstitutionAddress2,
    nin,
    financialInstitutionPostalCode,
    financialInstitutionMunicipalityCode,
    description,
  };
}
